import React from 'react'

import type { HeadLabelTooltipType } from '../../AnalyticsTable.types'
import * as S from './HeadLabelTooltip.styled'

type HeadLabelTooltipProps = HeadLabelTooltipType

export const HeadLabelTooltip = ({ title, description, type = 'text' }: HeadLabelTooltipProps) => {
  return (
    <S.Container>
      {title && <S.Title>{title}</S.Title>}
      <S.Description type={type}>{description}</S.Description>
    </S.Container>
  )
}
